import React from "react";

const CashbackIcon = (props) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12.75 6.5C12.75 6.086 12.414 5.75 12 5.75C11.586 5.75 11.25 6.086 11.25 6.5V7.301C9.601 7.585 8.5 8.857 8.5 10.357C8.5 12.043 9.886 13.25 11.5 13.25H12.5C13.328 13.25 14 13.819 14 14.643C14 15.466 13.328 16.036 12.5 16.036H11.5C10.672 16.036 10 15.466 10 14.643C10 14.229 9.664 13.893 9.25 13.893C8.836 13.893 8.5 14.229 8.5 14.643C8.5 16.143 9.601 17.415 11.25 17.699V18.5C11.25 18.914 11.586 19.25 12 19.25C12.414 19.25 12.75 18.914 12.75 18.5V17.699C14.399 17.415 15.5 16.143 15.5 14.643C15.5 12.957 14.114 11.75 12.5 11.75H11.5C10.672 11.75 10 11.181 10 10.357C10 9.534 10.672 8.964 11.5 8.964H12.5C13.328 8.964 14 9.534 14 10.357C14 10.771 14.336 11.107 14.75 11.107C15.164 11.107 15.5 10.771 15.5 10.357C15.5 8.857 14.399 7.585 12.75 7.301V6.5Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default CashbackIcon;
